module.exports = __webpack_public_path__ + "static/media/dark-modulo-gestao-servico.bec930e3.svg";